<template>
  <div class="rebateDisCode">
    <div class="titleBox">
      <span class="title">{{ $t("Fm2shortlinkbate.Fm2ShortLink") }}</span>
      <span class="content">{{ $t("Fm2shortlinkbate.LinkisaFast") }}</span>
    </div>

    <div class="newInfoBox">
      <el-steps :active="3" align-center>
        <el-step>
          <div slot="description" class="titOne">
            {{ $t("Fm2shortlinkbate.CreatetoShorten") }}<br />{{
              $t("Fm2shortlinkbate.CreatetoShorten2")
            }}
          </div>
        </el-step>
        <el-step>
          <div slot="description" class="titThree">
            {{ $t("Fm2shortlinkbate.clickyourlin") }}<br />{{
              $t("Fm2shortlinkbate.clickyourlin2")
            }}
          </div>
        </el-step>
        <el-step>
          <div slot="description" class="titOne">
            {{ $t("Fm2shortlinkbate.Earnmore") }}<br />{{
              $t("Fm2shortlinkbate.Earnmore2")
            }}
          </div>
        </el-step>
      </el-steps>
    </div>
    <div class="pub-tit0" style="margin-top: 40px;font-size: 18px;">
      {{ $t("Fm2shortlinkbate.Fm2Earnings") }}
    </div>
    <div class="newInfoBox2">
      <div class="Multiplemodels">
        {{ $t("Fm2shortlinkbate.Multiplemodels") }}
      </div>
      <!-- <div class="Direct">
        1、{{ $t("Fm2shortlinkbate.Directjump1")
        }}<span>{{ $t("Fm2shortlinkbate.Directjump2") }}</span
        >{{$i18n.locale == 'en'?'￥':''}}{{$store.state.userInfo?.short_url_price[0]}}{{ $t("Fm2shortlinkbate.Directjump3")
        }}<span>{{ $t("Fm2shortlinkbate.Directjump4") }}</span>
      </div> -->
      <!-- <div class="Direct">
        1、{{ $t("Fm2shortlinkbate.Loginjump1")
        }}<span>{{ $t("Fm2shortlinkbate.Loginjump2") }}</span
        >{{$i18n.locale == 'en'?'￥':''}}{{$store.state.userInfo?.short_url_price[0]}}{{ $t("Fm2shortlinkbate.Loginjump3")
        }}<span>{{ $t("Fm2shortlinkbate.Loginjump4") }}</span>
      </div> -->
      <div class="Direct">
        1、{{ $t("Fm2shortlinkbate.Miniadjump1")
        }}<span>{{ $t("Fm2shortlinkbate.Miniadjump2") }}</span
        >{{$i18n.locale == 'en'?'￥':''}}{{$store.state.userInfo?.short_url_price[1]}}{{ $t("Fm2shortlinkbate.Miniadjump3")
        }}<span>{{ $t("Fm2shortlinkbate.Miniadjump4") }}</span>
      </div>
      <!-- <div class="Direct">
        3、{{ $t("Fm2shortlinkbate.Feemooadjump1")
        }}<span>{{ $t("Fm2shortlinkbate.Feemooadjump2") }}</span
        >{{$i18n.locale == 'en'?'￥':''}}{{$store.state.userInfo?.short_url_price[2]}}{{ $t("Fm2shortlinkbate.Feemooadjump3")
        }}<span>{{ $t("Fm2shortlinkbate.Feemooadjump4") }}</span>
      </div> -->
      <div class="Direct">
        2、{{ $t("Fm2shortlinkbate.Extrareferralbonus1")
        }}<span>{{ $t("Fm2shortlinkbate.Extrareferralbonus2") }}</span
        ><span
          @click="$router.push('/referralProgram')"
          style="color: #7e72f6; cursor: pointer"
          >{{ $t("Fm2shortlinkbate.Extrareferralbonus3") }}</span
        >
      </div>
    </div>

    <!-- 写在这个位置 -->
    <div class="revenue-table-container">
      <div class="revenue-table">
        <div class="table-header-row">
          <div class="table-cell header">{{ $t("Fm2shortlinkbate.RevenueModel") }}</div>
          <div class="table-cell header">{{ $t("Fm2shortlinkbate.UserSteps") }}</div>
          <div class="table-cell header">{{ $t("Fm2shortlinkbate.Earningsper") }}</div>
          <div class="table-cell header">{{ $t("Fm2shortlinkbate.MultiEarnings") }}</div>
        </div>
        <!-- <div class="table-row">
          <div class="table-cell" style="color: #2c2c2c;">{{ $t("Fm2shortlinkbate.NoLoginJump") }}</div>
          <div class="table-cell">{{ $t("Fm2shortlinkbate.Clicklogin") }}</div>
          <div class="table-cell">{{$store.state.userInfo?.short_url_price[0]}}</div>
          <div class="table-cell">{{ $t("Fm2shortlinkbate.None") }}</div>
        </div> -->
        <!-- <div class="table-row">
          <div class="table-cell" style="color: #2c2c2c;">{{ $t("Fm2shortlinkbate.LoginJumps") }}</div>
          <div class="table-cell">{{ $t("Fm2shortlinkbate.Loginredirect") }}</div>
          <div class="table-cell">{{$store.state.userInfo?.short_url_price[0]}}</div>
          <div class="table-cell">{{ $t("Fm2shortlinkbate.Registervia") }}</div>
        </div> -->
        <div class="table-row">
          <div class="table-cell" style="color: #2c2c2c;">{{ $t("Fm2shortlinkbate.Miniprogram") }}</div>
          <div class="table-cell">{{ $t("Fm2shortlinkbate.WeChatQR") }}</div>
          <div class="table-cell">{{$store.state.userInfo?.short_url_price[1]}}</div>
          <div class="table-cell">{{ $t("Fm2shortlinkbate.Registervia") }}</div>
        </div>
        <!-- <div class="table-row">
          <div class="table-cell" style="color: #2c2c2c;">{{ $t("Fm2shortlinkbate.Appadjump") }}</div>
          <div class="table-cell">{{ $t("Fm2shortlinkbate.FeemooQR") }}</div>
          <div class="table-cell">{{$store.state.userInfo?.short_url_price[2]}}</div>
          <div class="table-cell">{{ $t("Fm2shortlinkbate.Registervia") }}</div>
        </div> -->
      </div>
    </div>

    <div class="pub-tit0" style="margin-top: 40px;font-size: 18px;">
      {{ $t("Fm2shortlinkbate.RevenueExplanation") }}
    </div>
    <div class="newInfoBox2">
      <div class="Direct">
        1、{{ $t("Fm2shortlinkbate.Shortearnings")
        }}<span>{{ $t("Fm2shortlinkbate.payoutdepends") }}</span>
      </div>
      <div class="Direct">
        2、{{ $t("Fm2shortlinkbate.Shortearningtitle")
        }}<span>{{ $t("Fm2shortlinkbate.Multiearnings") }}</span>
      </div>
      <div class="Direct">
        3、{{ $t("Fm2shortlinkbate.Invalidtraffic")
        }}<span>{{ $t("Fm2shortlinkbate.emulators") }}</span>
      </div>
      <div class="Direct">
        4、{{ $t("Fm2shortlinkbate.Rateadjustments")
        }}<span>{{ $t("Fm2shortlinkbate.thirdparty") }}</span>
      </div>
      <div class="Direct">
        5、{{ $t("Fm2shortlinkbate.Violationpolicy")
        }}<span>{{ $t("Fm2shortlinkbate.original") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.DataOverview2 {
  display: inline-block;
  font-weight: 400;
  font-size: 12px;
  color: #7e72f6;
  margin-left: 4px;
}
.newInfoBox2 {
  padding: 16px 20px;
  margin-top: 20px;
  background: #f9f9f9;
  border-radius: 12px;
  .Multiplemodels {
    font-weight: 500;
    font-size: 14px;
    color: #2c2c2c;
    line-height: 22px;
  }

  .Direct {
    font-weight: 400;
    font-size: 14px;
    color: #2c2c2c;
    line-height: 22px;
    margin-top: 8px;

    span {
      color: #8a8b92;
    }
  }
}
::v-deep .newInfoBox {
  padding: 32px 41px;
  margin-top: 32px;
  background: #f9f9f9;
  border-radius: 12px;
  .coTued {
    color: #7e72f6 !important;
  }
  .el-step__head.is-finish {
    color: #7e72f6;
    border-color: #7e72f6;
  }
  .el-step__description {
    margin-top: 9px;
    font-weight: 500;
    font-size: 13px;
    color: #2c2c2c;
    line-height: 18px;
    padding-left: 10%;
    padding-right: 10%;
    display: flex;
    align-items: center;
    justify-content: center;
    .titOne {
      width: 150px;
    }
    .titTwo {
      width: 150px;
    }
    .titThree {
      width: 160px;
    }
  }
  .el-step__line {
    height: 1px;
    background-color: #7e72f6;
  }
  .el-step__icon {
    width: 20px;
    height: 20px;
    border: none;
    background: #7e72f6;
    .el-step__icon-inner {
      font-weight: 400;
      font-size: 12px;
      color: #ffffff;
      line-height: 17px;
    }
  }
}
.rebateDisCode {
  padding-bottom: 40px;

  .titleBox {
    display: flex;
    flex-direction: column;
    .title {
      font-weight: 600;
      font-size: 18px;
      color: #2c2c2c;
      line-height: 24px;
      margin-bottom: 4px;
    }
    .content {
      font-weight: 400;
      font-size: 12px;
      color: #8a8b92;
      line-height: 20px;
    }
  }

  .revenue-table-container {
    margin-top: 20px;

    .table-header {
      margin-bottom: 16px;

      .understand-link {
        color: #7e72f6;
        font-size: 14px;
        text-decoration: none;
        font-weight: 400;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .revenue-table {
      background: #f9f9f9;
      border-radius: 12px;
      overflow: hidden;
      border: 1px solid #f6f6f6;

      .table-header-row {
        display: flex;
        background: #f9f9f9;

        .table-cell.header {
          background: #f9f9f9;
          font-weight: 500;
          color: #2c2c2c;
          font-weight: 500;
          font-size: 13px;
        }
      }

      .table-row {
        display: flex;
        background: #ffffff;
        box-shadow: inset 0px -1px 0px 0px #f6f6f6;

        &:nth-child(even) {
          background: #ffffff;
        }
      }

      .table-cell {
        padding: 14px 20px;
        font-size: 13px;
        line-height: 20px;
        color: #8A8B92;
        border-right: 1px solid #f0f0f0;
        display: flex;
        align-items: center;

        &:nth-child(1) {
          width: 220px;
          flex: none;
        }

        &:nth-child(2) {
          width: 260px;
          flex: none;
        }

        &:nth-child(3) {
          width: 192px;
          flex: none;
        }

        &:nth-child(4) {
          width: 260px;
          flex: none;
        }

        &:last-child {
          border-right: none;
        }

        &.header {
          font-weight: 500;
          color: #2c2c2c;
        }
      }
    }
  }
}
</style>
